import { render, staticRenderFns } from "./Delete.vue?vue&type=template&id=18b1aabd&scoped=true"
import script from "./Delete.vue?vue&type=script&lang=js"
export * from "./Delete.vue?vue&type=script&lang=js"
import style0 from "./Delete.vue?vue&type=style&index=0&id=18b1aabd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b1aabd",
  null
  
)

export default component.exports